import styled from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device, hexToRGB, typography } from '@/styles/helpers';

const tickCirclePrimaryIcon = getCDNImageUrl('/icon-img/tickCirclePrimary.svg');

export const ScDepositWithWageringDesktop = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  right: -90px;
  z-index: 16;
  background-color: ${({ theme }) => theme.grayLightColor};
  border-radius: 16px;
  overflow: hidden;
  width: 300px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.9);
  padding: 8px;

  .currencyBtn {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => theme.secondaryColor};
    height: 40px;
    .aware {
      background-color: transparent;
    }
    &:not(:disabled):hover {
      color: ${({ theme }) => theme.secondaryColorHover};
    }
    margin-top: 4px;
  }
`;

export const ScDepositWithWageringMobile = styled.div`
  .currencyBtn {
    margin-top: 24px;
  }
`;

export const ScDepositWithWageringContent = styled.div`
  .options {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 4px;

    & > .option,
    & > .activeOption {
      border-radius: 16px;
      padding: 8px;
      background: ${({ theme }) => hexToRGB(theme.blackColor, 0.2)};
      transition: color 0.2s;
      &:hover {
        color: ${({ theme }) => theme.whiteColor};
      }
      & .icon {
        width: 20px;
        height: 20px;
      }
      @media (${device.mobile}) {
        background-color: ${({ theme }) => theme.grayLightColor};
      }
    }

    & > .option {
      cursor: pointer;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${typography.body2regular};

      & .currency {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      @media (${device.mobile}) {
        padding: 16px;
      }
    }

    & > .activeOption {
      border: 1px solid;
      border-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.1)};

      .balanceContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tick-icon {
          width: 20px;
          height: 20px;
          background: ${() => `url(${tickCirclePrimaryIcon}) center no-repeat`};
        }

        .rightSide {
          display: flex;
          align-items: center;
          gap: 8px;

          .balances {
            ${typography.caption1regular};

            .real,
            .bonus {
              display: flex;
              justify-content: space-between;
              align-items: center;
              gap: 16px;
            }

            .label {
              text-align: right;
              min-width: 104px;
              color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
            }

            .real .value {
              ${typography.body2regular};
              font-weight: 700;
            }
          }
        }
      }

      .wageringBonuses {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .wageringContainer {
          .wagering {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 4px;
            ${typography.caption1regular};

            .label {
              color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
            }

            .link {
              display: flex;
              align-items: center;
              gap: 6px;
              margin-right: 6px;
              text-decoration: underline;
              color: ${({ theme }) => theme.secondaryColor};
              cursor: pointer;

              &:hover {
                color: ${({ theme }) => theme.secondaryColorHover};
              }

              .title {
                max-width: 22ch;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }

          .progressBar {
            margin: 4px 0;
          }

          .progressLeft {
            ${typography.caption2regular};
            display: flex;
            gap: 4px;

            .label {
              color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
            }
          }
        }

        .bonusesInQueue {
          display: flex;
          align-items: center;
          justify-content: center;
          ${typography.caption1regular};
          color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
          cursor: pointer;
          &:hover {
            color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.8)};
          }

          .icon {
            width: 16px;
            height: 16px;
            i {
              color: ${({ theme }) => theme.color2};
            }
          }
        }
      }
      .divider {
        width: 100%;
        height: 1px;
        background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
        margin: 8px 0;
      }
    }

    @media (${device.mobile}) {
      .notActiveWagering {
        padding: 16px;
      }
      .activeWagering {
        padding: 12px;
      }
    }
  }
`;
